import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'removeLeadingZeros' })
export class RemoveLeadingZerosPipe implements PipeTransform {

  transform(value: string):string{
    if(typeof value!== 'string'){
      return value;
    }
    return value.replace(/^0+/,"")||value;
  }
   

}
@Pipe({ name: 'noDecimal' })
export class NoDecimalPipe implements PipeTransform {

  transform(value: string,decimals:number):string{
    if(typeof value!== 'string'){
      return value;
    }
    console.log(decimals)
    return Intl.NumberFormat('en-US').format(Number(Number(value).toFixed(decimals)));
  }

}
@Pipe({ name: 'threeDecimal' })
export class ThreeDecimalPipe implements PipeTransform {

  transform(value: string,decimals:number):string{
    if(typeof value!== 'string'){
      return value;
    }
    if(value=='0'){
      return '0'
    }
    else{
      console.log(Intl.NumberFormat('en-US').format(Number(Number(value).toFixed(3))))
      return Intl.NumberFormat('en-US').format(Number(Number(value).toFixed(decimals)));
    } 
  }

}